module.exports = __webpack_public_path__ + "img/_0.6b949b2c.png";